// The gapi script (apis.google.com/js/client.js) is loaded with `defer` from
// public/index.html, so window.gapi is not guaranteed to exist at module
// evaluation time. Resolve it lazily on each call instead of capturing it once.

const GAPI_WAIT_TIMEOUT_MS = 10000;
const GAPI_POLL_INTERVAL_MS = 50;

export const getGapi = () => window.gapi;

async function waitForGapi() {
  const deadline = Date.now() + GAPI_WAIT_TIMEOUT_MS;

  while (!window.gapi?.client) {
    if (Date.now() > deadline) {
      throw new Error("[DEBUG_LOG] gapi client script failed to load within 10s");
    }
    await new Promise((resolve) => setTimeout(resolve, GAPI_POLL_INTERVAL_MS));
  }

  return window.gapi;
}

export let loaded = false;

export async function loadClient() {
  const gapi = await waitForGapi();
  gapi.client.setApiKey("AIzaSyBGlRmNXV14Z_iBFM5EkmbSf4RFUi8w-fU");
  await gapi.client.load("youtube", "v3");
  loaded = true;
}

export default getGapi;
